import { BreadcrumbItemProps } from '@gerdau/hefesto-mais-web/Breadcrumbs/Breadcrumbs.types';
import { EOrderSettingsRoutes } from '../../OrderSettingsMvp/orderSettings.routes';

interface ConfigurationPageProps {
  title: string;
  supportText: string;
}

const itemNavBuy = {
  name: 'Comprar',
  url: 'steel-type-choose'
};
const itemNavBuySelectingItems = {
  name: 'Comprar selecionando itens',
  url: '/'
};
const itemNavBuyBySheet = {
  name: 'Comprar via planilha',
  url: '/'
};
const itemNavBuyByHistory = {
  name: 'Comprar por histórico',
  url: '/'
};
const itemNavCatalog = {
  name: 'Comprar por vitrine',
  url: '/'
};

export const possibleBreadcrumbRoutes = [
  EOrderSettingsRoutes.REPEAT_ORDER,
  EOrderSettingsRoutes.SEARCH_ITEMS,
  EOrderSettingsRoutes.CATALOG,
  EOrderSettingsRoutes.SPREADSHEET_UPLOAD
];

export const pageBreadCrumbs: Record<string, BreadcrumbItemProps[]> = {
  'search-items': [itemNavBuy, itemNavBuySelectingItems],
  'spreadsheet-upload': [itemNavBuy, itemNavBuyBySheet],
  'repeat-order': [itemNavBuy, itemNavBuyByHistory],
  catalog: [itemNavBuy, itemNavCatalog]
};

export const headerTextContent: Record<string, ConfigurationPageProps> = {
  'search-items': {
    title: 'Comprar selecionando itens',
    supportText:
      'Selecione os produtos que deseja utilizando descrição ou código do material.'
  },
  'spreadsheet-upload': {
    title: 'Comprar por planilha',
    supportText:
      'Preencha e envie uma planilha com os dados dos produtos desejados para montar o seu carrinho.'
  },
  'repeat-order': {
    title: 'Comprar por histórico de pedidos',
    supportText:
      'Escolha um pedido feito anteriormente para montar seu carrinho.'
  },
  catalog: {
    title: 'Comprar por vitrine',
    supportText: 'Selecione seus produtos para configurar seu carrinho.'
  },
  'shopping-cart': {
    title: 'Configurar carrinho',
    supportText: 'Selecione as características dos produtos do seu pedido.'
  },
  checkout: {
    title: 'Revisar pedido',
    supportText: 'Revise todas as informações e finalize o seu pedido.'
  },
  'finalize-order': {
    title: 'Finalizar pedido',
    supportText: 'Confira as informações gerais do seu pedido.'
  }
};
